import APP_CONFIG from 'config/App.config';

const { language, storeId } = APP_CONFIG;

export const reformProductURL = (url: string, offerCode: string) => {
  if (!url) {
    return '';
  }
  let updatedUrl = `/${storeId}/${language}${url}`;
  if (offerCode) {
    updatedUrl = `${updatedUrl}?offer=offer_${offerCode}`;
  }
  return updatedUrl;
};
